/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HeadingSection, VFlow } from 'bold-ui'
import { BoxGroup } from 'components/BoxGroup'
import { resolveName } from 'components/form/final-form/useField'
import { SexoEnum } from 'graphql/types.generated'
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays'
import { isCboMedicoOuCirurgiaoDentista } from 'util/atendimento/cboMedicoOuCirurgiaoDentista'
import { MetaPath } from 'util/metaPath'
import { AtendimentoProfissional } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import EncaminhamentoExternoForm from '../EncaminhamentoExternoForm'
import EncaminhamentoExternoTable from '../list/EncaminhamentoExternoTable'
import { EncaminhamentoExternoModel, EncaminhamentoExternoPlanoModel } from '../model'

export interface EncaminhamentoExternoViewProps {
  name: MetaPath<EncaminhamentoExternoPlanoModel>
  prontuarioId: ID
  cidadaoSexo: SexoEnum
  cboAtendProf: string
  atendimentoProfissional: AtendimentoProfissional
  isAtendimentoOdonto: boolean
}

export default function EncaminhamentoExternoView(props: EncaminhamentoExternoViewProps) {
  const { name, prontuarioId, cidadaoSexo, cboAtendProf, atendimentoProfissional, isAtendimentoOdonto } = props
  const renderFieldArray = (fieldArrayRenderProps: FieldArrayRenderProps<EncaminhamentoExternoModel, any>) => {
    const {
      fields: { push, remove },
    } = fieldArrayRenderProps

    const renderCiapForm = !isCboMedicoOuCirurgiaoDentista(cboAtendProf)

    const handleSubmit = (value: EncaminhamentoExternoModel) => {
      push(value)
    }

    return (
      <HeadingSection
        level={3}
        title='Encaminhamentos para especialistas'
        vSpace={8}
        style={css`
          margin-top: 1rem;
        `}
      >
        <VFlow vSpacing={2}>
          <BoxGroup>
            <EncaminhamentoExternoForm
              prontuarioId={prontuarioId}
              onSubmit={handleSubmit}
              isAtendimentoOdonto={isAtendimentoOdonto}
              cidadaoSexo={cidadaoSexo}
              renderCiap={renderCiapForm}
              name={name}
            />
            <EncaminhamentoExternoTable
              prontuarioId={prontuarioId}
              name={name}
              atendimentoProfissional={atendimentoProfissional}
              remove={remove}
            />
          </BoxGroup>
        </VFlow>
      </HeadingSection>
    )
  }
  return <FieldArray name={resolveName(name.encaminhamentosRecentes)} render={renderFieldArray} />
}
